import { render, staticRenderFns } from "./ItemAttributeFilterNumeric.vue?vue&type=template&id=6406ab1c&scoped=true"
import script from "./ItemAttributeFilterNumeric.vue?vue&type=script&lang=ts"
export * from "./ItemAttributeFilterNumeric.vue?vue&type=script&lang=ts"
import style0 from "./ItemAttributeFilterNumeric.vue?vue&type=style&index=0&id=6406ab1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406ab1c",
  null
  
)

export default component.exports